<template>

    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="tasks" class="m-2"></b-icon>
                Plan de financement
            </p>
        </header>
        <section class="modal-card-body">

            <div class="has-text-centered">

                <h1 class="title">Détail des consommations d'enveloppes</h1>


                <hr>

                <b-table
                    :data="sumsByUser"
                    ref="table"
                    detailed
                    hoverable
                    striped
                    paginated
                    per-page="15"
                    custom-detail-row
                    detail-key="user"
                    show-detail-icon
                >

                    <b-table-column
                        field="user"
                        label="Chargé de projet / projet"
                        sortable
                        v-slot="props"
                        centered
                    >
                        <b>{{ props.row.user }}</b>
                    </b-table-column>

                    <b-table-column
                        field="sumsSub"
                        label="Montant sub demandé"
                        v-slot="props"
                        centered
                    >
                        <b>{{ props.row.sums.sumSub }} €</b>
                    </b-table-column>

                    <b-table-column
                        field="maxAllouable"
                        label="Max Allouable"
                        v-slot="props"
                        centered
                    >
                        <b>{{ props.row.maxAllouable }} €</b>
                    </b-table-column>

                    <b-table-column
                        field="warning"
                        label="Restant"
                        v-slot="props"
                        centered
                    >
                        <span
                            :class="['tag', getColor(props.row)]">
                            {{ props.row.maxAllouable - props.row.sums.sumSub }} €
                        </span>
                    </b-table-column>

                    <template slot="detail" slot-scope="props">
                        <tr
                            v-for="item in props.row.details"
                            :key="item.project">

                            <td></td>
                            <td>
                                {{ item.project }}
                            </td>


                            <td>
                                {{ item.sumSub }} €
                            </td>
                            <td>-</td>
                            <td>-</td>


                        </tr>

                    </template>

                </b-table>


            </div>

        </section>

        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Quitter
            </button>
        </footer>


    </div>
</template>

<script>

import _ from 'lodash'

export default {
    name: "DetailProject",
    props: {
        maxDetails: {
            type: Object,
            required: true
        },
    },
    computed: {},
    mounted() {
        // console.log(this.maxDetails.max.value);
        // console.log(this.maxDetails.conso.details);

        const groupedDetails = _.groupBy(this.maxDetails.conso.details, 'user');
        this.sumsByUser = _.map(groupedDetails, (details) => {
            const sums = {
                sum: _.sumBy(details, 'sum'),
                sumSub: _.sumBy(details, 'sumSub'),
                sumPresta: _.sumBy(details, 'sumPresta')
            };

            return {
                user: details[0].user,
                sums,
                details
            };
        });

        console.log(this.maxDetails.max.value)

        this.sumsByUser.forEach(s => {
            s.maxAllouable = this.maxDetails.max.value[s.user]
        })


    },
    methods: {
        getColor(row) {
            console.log(row);
            let delta = row.maxAllouable - row.sums.sumSub
            if (delta > 0) {
                return 'is-warning';
            } else if (delta === 0) {
                return 'is-success';
            } else {
                return 'is-danger';
            }
        },
    },
    data() {
        return {
            sumsByUser: []
        }
    },
}
</script>

<style scoped>

</style>
